<template>
    <div style="margin: 10px; height: 344px" class="lm-border">
        <div style="margin: 15px">
            <v-row class="no-frame pa-1 "
                   :class="favorite ? 'primary white--text' : 'black--text not-favorite'"
                   style="font-size: 11pt; border-radius: 4px; width: calc(100% + 2px); "
                   :style="favorite ? '' : 'border-width: 1px; border-style: solid;'"
            >
                <span class="pl-1">{{ calculation.unit.fabricNo  }}</span>
                <div style="font-size: 10px; padding-top: 6px">
                    <span class="pl-1">{{ calculation.unit.street  }}, </span>
                    <span class="pl-1">{{ calculation.unit.zip  }} {{ calculation.unit.city  }}</span>
                </div>
            </v-row>

            <inc-calculation
                :data     = "calculation"
                :form     = "form"
                :readonly = "readonly"
                :favorite = "favorite"
                :status   = "status"
                class     = "mt-2"
            />
        </div>
    </div>
</template>

<script>

import IncCalculation from "@/modules/inc/steps/components/repair/private/IncCalculation.vue";

export default {
    name: "IncBidCalculation",

    components: {
        IncCalculation
    },

    props: {
        calculation: {
            required: true
        },
        favorite: {
            required: true
        },
        status: {

        },
        form: {

        },
        readonly: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        }
    },

    data: () => ({
        priceOriginalError: [],
        costMaterialError : [],
        costWageError     : []
    }),

    watch: {
        bid: {
            deep: true,
            handler: function () {
                this.$nextTick(() => {
                    this.form.validate();
                });
            }
        }
    },

    /*
    computed: {
        costPriceRule () {
            return this.validateCostsAgainstPrice;
        },

        sum () {
            if (this.bid === null) {
                return "";
            }

            const sum = this.bid.costMaterial + this.bid.costWage;
            if (Number.isNaN(sum) === true) {
                return "";
            }

            return Core.money (sum);
        }
    },

    methods: {
        validateCostsAgainstPrice ()  {
            if ((!this.bid.priceOriginal || this.bid.priceOriginal === 0) && (this.bid.costMaterial || this.bid.costWage)) {
                return this.setError("inc.bid.error.cost-without-price");
            }

            if (this.bid.priceOriginal !== 0) {
                const sum = this.bid.costMaterial + this.bid.costWage;
                if (sum !== 0 && sum !==  this.bid.priceOriginal) {
                    return this.setError("inc.bid.error.cost-price-difference");
                }
            }

            return this.clearError();
        },

        setError (text) {
            this.priceOriginalError = [this.$t(text)];
            this.costMaterialError  = [""];
            this.costWageError      = [""];
            return false;
        },

        clearError () {
            this.priceOriginalError = [];
            this.costMaterialError  = [];
            this.costWageError      = [];
            return true;
        }
    }

     */
}
</script>

<style scoped>
.invoice-costs-sum {
    font-size: 12pt;
    text-align: right;
    height: 25px;
    width: 100%;
    padding-right: 0;
    background-color: white!important;
    border: none;
    border-bottom-style: double;
    border-bottom-color: #ced4da;
}

.money ::v-deep input{
    text-align: right;
}

.equals {
    float: left;
    font-size: 9pt;
    padding-top: 5px;
}

</style>